import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-73c3aac5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "search-box",
  ref: "searchBox"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item");
  const _component_el_carousel = _resolveComponent("el-carousel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_carousel, {
    height: $data.height + 'px'
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgList, item => {
      return _openBlock(), _createBlock(_component_el_carousel_item, {
        key: item
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: item.url,
          alt: ""
        }, null, 8, _hoisted_2)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["height"])], 512);
}